import { render, staticRenderFns } from "./mobileorderhistory.vue?vue&type=template&id=5bc5ec1e&"
import script from "./mobileorderhistory.vue?vue&type=script&lang=js&"
export * from "./mobileorderhistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports